import styled from "styled-components";

export const ContentPlans = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  width: 100%;
  padding: 2rem;

  color: var(--secondary-color);

  text-align: center;
`;

export const ContainerPlans = styled.div`
  --card-width: 14.5rem;
  --gap: 1rem;

  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-wrap: wrap;
  gap: var(--gap);

  max-width: calc(var(--card-width) * 3 + var(--gap) * 2);
`;

export const PlanCard = styled.button`
  all: unset;
  width: var(--card-width);

  cursor: pointer;

  img {
    width: 100%;
    height: auto;
  }
`;
